import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthRoute, NavLink, Redirect, Switch, useRouteMatch } from '@fs/zion-router'
import { usePageView } from '@fs/zion-analytics'
import { SubSubNav } from '../app/SubnavAndRoutes'
import Lists from './lists/Lists'
import AdminMerge from './adminMerge/AdminMerge'
import DatsJobs from './distributed/allJobs/DatsJobs'
import { DatsJobBase } from './distributed/Jobdetails/DatsJobBase'
import CreateOSR from './createOSR/CreateOSR'
import { PermissionsContext } from '../app/PermissionsContext'
import { IdConverter } from './idConverter/IdConverter'
import Reservation110YearApproval from '../reservation/Reservation110YearApproval'
import RftBase from './rftQueries/RftBase'
import AdminLabels from './adminLabels/AdminLabels'
import Reports from './dmqReports/Reports'
import { usePageTitle } from '../app/PageTitleContext'

export default function ToolsBase() {
  usePageView({ page_detail: 'DMConsole:ToolsBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tools.base'))
  const match = useRouteMatch()
  const reportsMatch = useRouteMatch(`${match.path}/reports`)
  const { isAuthorized, isRole } = useContext(PermissionsContext)

  return (
    <>
      <SubSubNav bottomLine>
        <NavLink to={`${match.url}/adminMerge`}>{t('tools.adminMerge.adminMerge', 'Admin Merge')}</NavLink>
        <NavLink to={`${match.url}/createOSR`}>{t('tools.createOSR.createOSR', 'Create OSR')}</NavLink>
        <NavLink to={`${match.url}/idConverter`}>{t('tools.idConverter', 'Id Converter')}</NavLink>
        {isAuthorized('ModifySensitiveMatchTermsPermission') && (
          <NavLink to={`${match.url}/lists`}>{t('tools.lists.lists', 'Lists')}</NavLink>
        )}
        {isRole(['Data Admin 4', 'Data Admin 5', 'Data Admin 6']) && (
          <NavLink to={`${match.url}/admin-labels`}>{t('tools.adminLabels', 'Admin Labels')}</NavLink>
        )}
        {isRole(['110 Year Admin', 'Russian 110 Year Admin']) && (
          <NavLink to={`${match.url}/110yearApproval`}>{t('tools.110year', '110-Year')}</NavLink>
        )}
        {isAuthorized('ViewDistributedAdminToolPermission') && (
          <NavLink to={`${match.url}/distributed`}>{t('tools.distributed.distributed', 'Distributed')}</NavLink>
        )}
        {isRole(['Data Admin 4', 'Data Admin 5', 'Data Admin 6']) && (
          <NavLink to={`${match.url}/rftQueries`}>{t('tools.rftQueries', 'RFT Queries')}</NavLink>
        )}
        {isRole(['Data Admin 6']) && reportsMatch && (
          <NavLink to={`${match.url}/reports`}>{t('tools.reports', 'Reports')}</NavLink>
        )}
      </SubSubNav>

      <Switch>
        <Redirect exact from={`${match.path}`} to={`${match.path}/adminMerge`} />
        <AuthRoute exact path={`${match.path}/adminMerge`} component={AdminMerge} />
        <AuthRoute exact path={`${match.path}/createOSR`} component={CreateOSR} />
        {isAuthorized('ModifySensitiveMatchTermsPermission') && (
          <AuthRoute exact path={`${match.path}/lists`} component={Lists} />
        )}
        {isRole(['Data Admin 4', 'Data Admin 5', 'Data Admin 6']) && (
          <AuthRoute exact path={`${match.path}/admin-labels`} component={AdminLabels} />
        )}
        <AuthRoute exact path={`${match.path}/idConverter`} component={IdConverter} />
        {isRole(['110 Year Admin', 'Russian 110 Year Admin']) && (
          <AuthRoute exact path={`${match.path}/110yearApproval`} component={Reservation110YearApproval} />
        )}
        {isRole(['Data Admin 4', 'Data Admin 5', 'Data Admin 6']) && (
          <AuthRoute path={`${match.path}/rftQueries`} component={RftBase} />
        )}
        {isRole(['Data Admin 6']) && <AuthRoute exact path={`${match.path}/reports`} component={Reports} />}
        {isAuthorized('ViewDistributedAdminToolPermission') && (
          <>
            <AuthRoute exact path={`${match.path}/distributed`} component={DatsJobs} />
            <AuthRoute exact path={`${match.path}/distributed/:jobId`} component={DatsJobBase} />
          </>
        )}
      </Switch>
    </>
  )
}
